import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogActions } from '@angular/material/dialog';
import { FormGroup, Validators, FormBuilder, Form, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Servidor } from 'src/app/shared/model/fise/servidor.model';
import { FiseService } from '../../fise.service';
import swal from 'sweetalert2';
import { UsuarioFise } from 'src/app/shared/model/security/userbean.model';
import { DatatableCompatDirective } from 'src/app/shared/datatables-compat/datatable-compat.module';
import { Aplicacion } from 'src/app/shared/model/fise/aplicacion.model';
import { ConsultaList } from 'src/app/shared/model/core/ConsultaList.model';
import { Config } from 'datatables.net';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatInput, MatError, MatLabel } from '@angular/material/input';
import { SoloDireccionesIpDirective } from '../../../utilerias/directives/solo-direcciones-ip.directive';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { SoloLetraEspacioNumeroAcentoDirective } from '../../../utilerias/directives/solo-letra-espacio-numero-acento.directive';
import { NotCopyPasteDirective } from '../../../utilerias/directives/not-copy-paste.directive';
import { NgIf, NgFor } from '@angular/common';

@Component({
    selector: 'app-modal-servidor',
    templateUrl: './modal-servidor.component.html',
    styleUrls: ['./modal-servidor.component.css'],
    imports: [MatIconButton, MatIcon, FormsModule, ReactiveFormsModule, MatFormField, MatInput, MatLabel, SoloDireccionesIpDirective, MatRadioGroup, MatRadioButton, SoloLetraEspacioNumeroAcentoDirective, NotCopyPasteDirective, NgIf, MatError, NgFor, MatButton, MatDialogActions]
})
export class ModalServidorComponent implements OnInit {
  formGroupServidor: FormGroup;
  formGrouplistaUsuarios : FormGroup;
  formGroupUsuario: FormGroup;
  tituloOperacion: string;
  perfilesValidos: boolean;
  tblDirective: DatatableCompatDirective;
  test: boolean = true;
  listUsuarios: UsuarioFise[] = [];
  objectUusuario: UsuarioFise;
  objectServidor: Servidor;
  tblUsuariosPaginacion: Config = {};
  listaUs: Array<UsuarioFise>;
  aplicacionSelect = new Aplicacion;
  usuarioedit = new UsuarioFise();

  totalRegistrosUsuarioxServidor: number = 0;
  reqConsultaUsuarioApp = new ConsultaList<UsuarioFise>();
  seccionActiva: 'servidor' | 'usuarios' = 'servidor';
  mostrarFormularioUsuario = false;
  constructor(public modalDialog: MatDialogRef<ModalServidorComponent>, public modalDialogs: MatDialog,
    @Inject(MAT_DIALOG_DATA) public serverEdit: Servidor,
    private formBuilder: FormBuilder, private servidorService: FiseService, 
    private cdref: ChangeDetectorRef) { }
    taskTypeAreas: any[];
    selectedOptions: any[];
    get formServ()  {return this.formGroupServidor.controls; }
    get formUser()  {return this.formGroupUsuario.controls; }
  ngOnInit() {
   
    this.objectServidor = new Servidor();
    this.objectUusuario = new UsuarioFise();
    this.formGroupServidor = this.formBuilder.group({
      controlIp: ['', Validators.required],
      controlSOperativo: ['', Validators.required],
      controlUbicacion: ['', Validators.required],
      controlTipo:  ['', Validators.required],
      controlDescripcion: ['', [Validators.required]],
    });

    this.formGroupUsuario = this.formBuilder.group({
      controlUs: ['', Validators.required],
      controlPass: ['', Validators.required],
      controlDesc: ['', Validators.required],
      controlTipoU: ['', Validators.required]
    });

    if (this.serverEdit.id_Servidor == null) {
      this.onClicAgregarUsuario(true);
      this.tituloOperacion = "Alta";
    }
    else {
      this.onClicAgregarUsuario(false);
      this.tituloOperacion = "Edición";
      this.consultarUsuarios();
    }
    this.objectServidor = this.serverEdit;
    this.objectUusuario = this.usuarioedit;
  }

  onClicCerrarModal(): void {
    this.modalDialog.close();
  }

  abrirSeccion(seccion: 'servidor' | 'usuarios'): void {
    this.seccionActiva = seccion;
  }

  onClicGuardar(): void {

    if (!/^[0-9.]+$/.test(this.objectServidor.ip)) {
      // Mostrar mensaje de error
      swal.fire({
        title: 'ERROR',
        text: 'El campo IP solo puede contener números y puntos',
        buttonsStyling: false,
        customClass:{
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger',
        },
        confirmButtonText: 'Aceptar',
        icon: 'warning'
      });
      return;
    }

  
    console.log(this.tituloOperacion);
  
    var usuarioreq = new UsuarioFise();
    usuarioreq.id_Servidor = this.objectServidor.id_Servidor;
    usuarioreq.usuario = this.objectUusuario.usuario;
    this.reqConsultaUsuarioApp.bean = usuarioreq;
    console.log(this.objectUusuario.usuario);
  
    this.objectServidor.userObject = this.listUsuarios;
    this.servidorService.ServidorGuardaroActulizar(this.objectServidor).subscribe(response => {
      console.log(this.objectServidor.ip);
  
      if (response.pCodRetorno === '00000') {
        swal.fire({
          title: response.pCodRetorno === '00000' ? 'ÉXITO' : 'ERROR',
          text: response.pMensaje,
          buttonsStyling: false,
          customClass:{
            confirmButton: 'btn btn-success',
            cancelButton: 'btn btn-danger',
          },
          confirmButtonText: 'Aceptar',
          icon: response.pCodRetorno === '00000' ? 'success' : 'warning'
        }).then(responseMsG => {
          this.modalDialog.close(response.pCodRetorno);
          this.objectServidor = new Servidor();
        })
      } else {
        swal.fire({
          title: response.pCodRetorno === '00001' ? 'ERROR' : 'ÉXITO',
          text: response.pMensaje,
          buttonsStyling: false,
          customClass:{
            confirmButton: 'btn btn-success',
            cancelButton: 'btn btn-danger',
          },
          confirmButtonText: 'Aceptar',
          icon: 'warning'
        }).then(responseMsG => {
          console.log("IP ya registrado");
        });
      }
    });
  }
  




  

  onClicAgregarUsuario(agregar:boolean){
    this.mostrarFormularioUsuario = agregar;
  }
  onClicAddUS(): void {
    var usuarios : string;
    var compara : boolean;
    for (let i=0 ; i < this.listUsuarios.length ;i++){
      usuarios = this.listUsuarios[i].usuario.toString();
      console.log(usuarios);
      if (usuarios.toUpperCase()===this.objectUusuario.usuario.toUpperCase()){
        console.log("Ya existe");
        compara= true;
      }
    }
    if (compara == true){
      this.onClicAgregarUsuario(true)
      swal.fire({
        title: "ERROR",
        
        text: 'El nombre de usuario que desea ingresar ya existe',
        buttonsStyling: false,
        customClass:{
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger',
        },
        confirmButtonText: 'Aceptar',
        icon: 'warning'
      }).then(responseMsG => {
        
      })

    }else{
      this.listUsuarios.push(this.objectUusuario);
      
      this.objectUusuario= new UsuarioFise();
      this.formGroupUsuario.reset();
      this.onClicAgregarUsuario(false);

    }   
  }

  onClicQuitaruser(usuarioB : string): void {
    console.log(usuarioB);
    var usuarios : string;
    for (let i=0 ; i < this.listUsuarios.length ;i++){
      usuarios = this.listUsuarios[i].usuario.toString();
      if (usuarios==usuarioB){
        var numero :number;
        numero=i;
        console.log("Borrar");
 
      }
    }
    this.listUsuarios.splice(numero, 1)
    
  }
     
  consultarUsuarios(){
    var usuarioreq = new UsuarioFise();
    usuarioreq.id_Servidor = this.serverEdit.id_Servidor
    console.log(this.serverEdit.id_Servidor)
    console.log(this.objectServidor.id_Servidor)
    this.servidorService.ObtenerUsuarios(usuarioreq).subscribe(res =>{
      this.listUsuarios = res.list;
    });
    
  }
  
}
